export default "__VITE_ASSET__DpO7aKnD__"